import React, { Component } from "react";
import { injectIntl, defineMessages } from "react-intl";
import ReactTable, { ReactTableDefaults } from "react-table";

import { Loading, EduTemplateInTableMenu, TempStatistics, ReactTableFilterDatePicker, ReactTableSearch, ReactTablePagination, ReactTableHeaderText } from "components";

import { Icon, Label, Popup, Image } from "semantic-ui-react";

import * as commonVar from "libs/commonVar";

import moment from "moment";
import "moment/locale/ko";
import "moment/locale/ja";

import classNames from "classnames/bind";
import styles from "./EduTemplateList.css";
const cx = classNames.bind(styles);

moment.locale(localStorage.getItem("language"));
class EduTemplateList extends Component {
  render() {
    const { formatMessage } = this.props.intl;
    const { data, fromNowView, isAuth, ...rest } = this.props;
    // 검색 (상단)
    const { searchObj } = this.props;
    // 필터
    const { handleChangeDateFilter, isBasicFilter, phishingLevelFilter, downloadTypeTemplateFilter, filterClose, executeFilter, onFilterCancel } = this.props;

    // 현재 페이지 이동 (하단)
    const { handlePagination } = this.props;

    const columns = [
      {
        Header: <ReactTableHeaderText title={<Icon name="setting" />} />,
        resizable: false,
        sortable: false,
        width: 130,
        headerClassName: cx("react-table-th"),
        className: cx("react-table-td", "justify-center"),
        Cell: ({ original }) => {
          return <EduTemplateInTableMenu isAuth={isAuth} dataInfo={{ ...original }} />;
        },
      },
      {
        // No
        Header: <ReactTableHeaderText title={"No"} />,
        accessor: "eduAttachNo",
        sortable: true,
        resizable: false,
        minWidth: 80,
        headerClassName: cx("react-table-th"),
        className: cx("react-table-td", "text-align-center number-text"),
        Cell: ({ value }) => {
          let printValue = "-";
          if (value) {
            printValue = value;
          }
          return printValue;
        },
      },
      {
        Header: <ReactTableHeaderText title={defineMessages(formatMessage({ id: "EduTemplate_1", defaultMessage: "컨텐츠명" }))} />,
        accessor: "attachName",
        sortable: true,
        minWidth: 300,
        headerClassName: cx("react-table-th"),
        className: cx("react-table-td"),
      },
      {
        Header: <ReactTableHeaderText title={defineMessages(formatMessage({ id: "EduTemplate_2", defaultMessage: "영상 개수" }))} />,
        accessor: "fileCount",
        sortable: true,
        minWidth: 80,
        headerClassName: cx("react-table-th"),
        className: cx("react-table-td text-align-center"),
        Cell: ({ value }) => {
          let printValue = "-";
          if (value) {
            printValue = value;
          }
          return printValue;
        },
      },
      {
        Header: ({ ...rest }) => {
          return (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: "ExamTemplateList_17", defaultMessage: "등록일시" }))}
              filter={
                <ReactTableFilterDatePicker
                  {...rest}
                  filter={searchObj.filterData}
                  onChange={(data) => {
                    handleChangeDateFilter("RegEpoch", data);
                  }}
                />
              }
            />
          );
        },
        accessor: "regEpoch",
        minWidth: 150,
        resizable: false,
        sortable: true,
        headerClassName: cx("react-table-th", "overflow-visible"),
        className: cx("react-table-td", "text-align-center sub-text"),
        Cell: ({ value }) => {
          const dateFormat = localStorage.getItem("language") === "en" ? "MM/DD/YYYY" : "YYYY-MM-DD";
          return (
            <div>
              <span className={cx("log-reg-date-normal")}>{moment.unix(value).format(dateFormat + " HH:mm:ss")}</span>
              <span className={cx("log-reg-date-fromnow")}>{moment.unix(value).fromNow()}</span>
            </div>
          );
        },
      },
    ];

    const { TbodyComponent: tbadyWrapper } = ReactTableDefaults;
    return (
      <div className={cx("react-table-area", fromNowView ? "from-now-view" : "")}>
        <ReactTableSearch
          searchObj={searchObj}
          listData={data}
          //필터 영역
          filters={{
            isBasicFilter: isBasicFilter,
            phishingLevelFilter: phishingLevelFilter,
            downloadTypeTemplateFilter: downloadTypeTemplateFilter,
          }}
          filterClose={filterClose}
          executeFilter={executeFilter}
          onFilterCancel={onFilterCancel}
        />
        <div className={cx("react-table")}>
          <ReactTable
            columns={columns}
            data={data}
            sortable={false}
            filterable={false}
            showPagination={false}
            showPageSizeOptions={false}
            defaultSorted={[
              {
                id: "regEpoch",
                desc: true,
              },
            ]}
            loadingText={defineMessages(formatMessage({ id: "ExamTemplateList_23", defaultMessage: "데이터 로딩중..." }))}
            LoadingComponent={({ ...rest }) => <Loading active={rest.loading} content={rest.loadingText} />}
            FilterComponent={({ ...rest }) => <div />}
            TbodyComponent={({ ...rest }) => (
              <div style={{ ...rest.style }} className={cx("react-table-tbody-wrapper")}>
                <tbadyWrapper {...rest} className={cx("rt-tbody", rest.className ? rest.className : "", data.length < 2 ? "single" : "")} />
              </div>
            )}
            NoDataComponent={({ ...rest }) => (
              <div className={cx("noData-area")}>
                <Image src="/img/table/nodata_icon.png" />
                {defineMessages(formatMessage({ id: "ExamTemplateList_24", defaultMessage: "데이터가 없습니다." }))}
              </div>
            )}
            getTheadThProps={(state, rowInfo, column) => {
              const filter = [];
              if (column) {
                // 필터 처리
                if (typeof searchObj.filterData[column.id] !== "undefined") {
                  filter.push("isFiltered");
                }
                // 정렬 제공 안하는 header
                if (!column.sortable) {
                  filter.push("no-sort");
                }

                return filter.length > 0
                  ? {
                      className: filter.join(" "),
                    }
                  : {};
              }
            }}
            getTrProps={(state, rowInfo, column) => {
              if (rowInfo && rowInfo.original && rowInfo.original.isEnable === 0) {
                return {
                  className: "delete-item",
                };
              } else {
                return {};
              }
            }}
            minRows={data ? (data.length !== 0 && data.length < 2 ? 2 : data.length) : searchObj.defaultPageSize}
            {...rest}
          />
        </div>
        <ReactTablePagination currentPage={rest.page} totalPages={rest.pages ? rest.pages : 0} handlePagination={handlePagination} />
      </div>
    );
  }
}

export default injectIntl(EduTemplateList);



// WEBPACK FOOTER //
// ./src/script/components/eduTemplate/EduTemplateList.js